import type { PortableTextBlock } from '@portabletext/react';
import type { SanityAsset } from '@sanity/image-url';
import cn from 'classnames';
import Icon from '../../generic/Icon';
import getFormattedDate from '../../utils/getFormattedDate';
import prettyBytes from '../../utils/prettyBytes';
import type { ImageWithMetadata} from '../components/SanityImage';
import SanityImage, { imageWithMetadataGroq } from '../components/SanityImage';
import SimpleRichText from './SimpleRichText';
import * as style from './richText.module.css';

export interface FileComponentProps {
    _type: 'fileComponent';
    _updatedAt?: string;
    title: string;
    showUpdatedAt?: boolean;
    file: {
        asset: SanityAsset & {
            size: number;
        };
    };
    text?: PortableTextBlock[];
    image?: ImageWithMetadata;
    useImage?: boolean;
}

export const fileComponentGroq = /* groq */ `{
    _id,
    _updatedAt,
    title,
    showUpdatedAt,
    file {
        asset->
    },
    text[],
    useImage,
    image ${imageWithMetadataGroq}
}`;

export default function FileComponent({ value, float, category }: { value: FileComponentProps; float?: 'left' | 'right'; category?: string }) {
    if (!value) return;

    return (
        <div className={cn(style.fileComponent, { float }, float)}>
            <a href={value.file?.asset.url} download>
                <SanityImage image={value.useImage ? value.image : undefined} widths={[100, 100 * 2]} sizes="100px" aspectRatio={1} lazy />
                <div className={style.description}>
                    {category && <span className={style.category}>{category}</span>}
                    <h3>{value.title}</h3>
                    {value.text && <SimpleRichText value={value.text} />}
                    {value.showUpdatedAt && (
                        <p>
                            Sist oppdatert:{' '}
                            <time dateTime={value._updatedAt} suppressHydrationWarning>
                                {getFormattedDate(value._updatedAt, 'date_time')}
                            </time>
                        </p>
                    )}
                </div>
                {value.file?.asset && (
                    <span className={style.fileInfo}>
                        {value.file.asset.extension} {prettyBytes(value.file.asset.size)}
                        <Icon className="icon-download" />
                    </span>
                )}
            </a>
        </div>
    );
}
